import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "w-full" };
const _hoisted_2 = { class: "flex justify-between items-center" };
const _hoisted_3 = { class: "flex justify-between items-center" };
import { ProgressBar } from "primevue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UProgressBar',
    props: {
        procent: {
            type: Number,
            default: 0
        },
        green: {
            type: Boolean,
            default: false
        },
        isLoader: {
            type: Boolean,
            default: false
        }
    },
    setup(__props) {
        const props = __props;
        const cssVars = {
            "--progress-color-main": props.green ? "#28E593" : "#d8dad9",
            "--progress-color-bg": props.green ? "#28E59340" : "#eff1f0"
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "top-left"),
                    _renderSlot(_ctx.$slots, "top-right")
                ]),
                _createVNode(_unref(ProgressBar), {
                    mode: __props.isLoader ? 'indeterminate' : 'determinate',
                    style: cssVars,
                    "show-value": false,
                    value: __props.procent
                }, null, 8, ["mode", "value"]),
                _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "bottom-left"),
                    _renderSlot(_ctx.$slots, "bottom-right")
                ])
            ]));
        };
    }
});
